import event from 'event'
if (!window.Bus) {
  window.Bus = {}
  event.mixin(window.Bus)
}
let bus = window.Bus

bus.mixin = (target) => {
  ['on', 'off', 'emit', 'once'].forEach((method) => {
    if (typeof target === 'function') {
      target.prototype[method] = bus[method].bind(bus)
    } else {
      target[method] = bus[method].bind(bus)
    }
  })
}
module.exports = bus



// WEBPACK FOOTER //
// ./src/mods/bus.js